import React from 'react';
import '../stylesheet/Copyright.css';
import '../stylesheet/style.css';
  
export default function Copyright() {
    return (
        <div className='copyright'>
            <p>©<span>Mohamed Sajfan</span></p>
        </div> 
    );
}